import { Box, Card, CardContent } from '@mui/material';
import type React from 'react';
import BlobJellyfish from './blob-jellyfish.js';
import BlobOrigami from './blob-origami.js';
import type { GenericProps } from './generic/generic.js';
import Generic from './generic/index.js';

export type ErrorProps = {
  readonly title?: string;
  readonly message?: string;
};

const Container: React.FC<{ readonly children: React.ReactNode }> = ({ children }) => {
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        overflow: 'hidden'
      }}
    >
      {children}
    </Box>
  );
};

export function buildErrorContainer(ErrorComponent = Generic): React.FC {
  const _Error: React.FC<ErrorProps> = () => {
    return (
      <Container>
        <ErrorComponent />
      </Container>
    );
  };

  _Error.displayName = 'Error';
  return _Error;
}

export default function buildError(ErrorComponent = Generic): React.FC<GenericProps> {
  const _Error: React.FC<ErrorProps> = (props) => {
    const { title, message } = props;
    return (
      <Container>
        <BlobJellyfish style={{ opacity: '0.35', height: '50%', marginLeft: '-15%' }} />
        <Card sx={{ alignSelf: 'center', width: '100%' }}>
          <CardContent sx={{ ':last-child': { paddingBottom: 2 } }}>
            <ErrorComponent title={title} message={message} />
          </CardContent>
        </Card>
        <BlobOrigami
          style={{
            alignSelf: 'flex-end',
            opacity: '0.35',
            height: '50%',
            marginRight: '-15%'
          }}
        />
      </Container>
    );
  };

  _Error.displayName = 'Error';
  return _Error;
}
